import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// ✅ Fetch Loan List by Customer
export const get_loan_list = createAsyncThunk("loan/list", async (data) => {
  const body = new FormData();
  body.append("action", "loan_list");
  body.append("userid", data.userid);

  const response = await fetch(baseUrl + "loan.php", {
    method: "POST",
    body,
  });
  const res = await response.json();
  return res;
});

const initialState = {
  loanList: [],
  loading: false,
  error: null,
};

const LoanSlice = createSlice({
  name: "loan",
  initialState,
  reducers: {
    clearLoanList: (state) => {
      state.loanList = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // ✅ Loan List
    builder.addCase(get_loan_list.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(get_loan_list.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
      state.loanList = [];
    });
    builder.addCase(get_loan_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      if (data.success) {
        state.loanList = data.data || [];
        state.error = null;
      } else {
        state.loanList = [];
        state.error = data.message || "Failed to fetch loan list";
      }
    });
  },
});

export const { clearLoanList } = LoanSlice.actions;
export default LoanSlice.reducer;